import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { BoxShadow, BorderRadius } from '../../../../shared/GlobalStyles';
import Text from '../../../../shared/components/Text/Text';

const InfoCardContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: space-between;
  min-width: 333px;
  width: 333px;
  padding: 30px;
  border-radius: ${BorderRadius};
  box-shadow: ${BoxShadow};
  @media screen and (max-width: 530px) {
    min-width: 0px!important;
  }
`;

const InfoCardRow = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const InfoDetailsContainer = styled('div')`
  flex: 10;
`;

const InfoSideDetailsContainer = styled('div')`
  flex: 2;
`;

const InfoCard = ({
  InfoDetails,
  InfoSideDetails,
}) => (
  <InfoCardContainer
    className='info-card'
  >
    <InfoCardRow>
      <InfoDetailsContainer
        className='info-details-container'
      >
        {InfoDetails}
      </InfoDetailsContainer>
      <InfoSideDetailsContainer>
        {InfoSideDetails}
      </InfoSideDetailsContainer>
    </InfoCardRow>
    <InfoCardRow>
      <Text fontSize={12} fontStyle='italic'>Note: Price displayed may not include applicable taxes.</Text>
    </InfoCardRow>
  </InfoCardContainer>
);

InfoCard.propTypes = {
  InfoDetails: PropTypes.element.isRequired,
  InfoSideDetails: PropTypes.element.isRequired,
};

export default InfoCard;
